import React from 'react';
import cls from './EmptyBody.module.css';
import { Trans, useTranslation } from 'react-i18next';
import { Flex, UiText } from '@shared/ui';

interface EmptyBodyProps {
    classes?: string;
}

export const EmptyBody = ({ classes }: EmptyBodyProps) => {
    const { t } = useTranslation();
    return (
        <Flex fullWidth direction={'column'} gap={8} className={cls.EmptyBody}>
            <UiText variant={'heading'} tag={'h1'} weight={'bold'}>
                {t('RequestsTableBody.empty.UiText.heading')}
            </UiText>
            <UiText align={'center'}>
                <Trans i18nKey={'RequestsTableBody.empty.UiText.content'} />
            </UiText>
        </Flex>
    );
};
